'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var rotateInDownRight = {
  from: {
    transformOrigin: 'right bottom',
    transform: (0, _utils.rotate3d)(0, 0, 1, 45),
    opacity: 0
  },
  to: {
    transformOrigin: 'right bottom',
    transform: 'none',
    opacity: 1
  }
};
exports.default = rotateInDownRight;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/rotate-in-down-right.js
// module id = 2150
// module chunks = 0